const SHY = '­'

const COMPOUNDS: Readonly<Record<string, string>> = Object.fromEntries(
  ['Teilnehmer·akte', 'Potenzial·analyse', 'Kompetenz·feststellung', 'Kompetenz·bilanzierung', 'Zwischen·bericht'].map((word) => [
    word.replaceAll('·', ''),
    word.replaceAll('·', SHY),
  ]),
)

export const withCompoundBreaks = (title: string): string =>
  title.replace(/[\p{L}]+/gu, (word) => COMPOUNDS[word] ?? word)
